import type {AiRedesignPromptBoxProps} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import type {VoidFunction} from "@Utils/general.util";

export const PANEL_ID = 'ai-redesign-prompt-box-panel';

export interface AiRedesignPromptBoxPanel extends AiRedesignPromptBoxProps {
  title: string;
  icon: string;
  onClose?: VoidFunction;
}
